import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * 2 way to use this component:
 * <ap-switch-toggle formControlName='myFormControl'></ap-switch-toggle>
 * or
 * <ap-switch-toggle [(checked)]='myVariable'></ap-switch-toggle>
 */
@Component({
    selector: 'ap-switch-toggle',
    templateUrl: './switch-toggle.component.html',
    styleUrl: './switch-toggle.component.css',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SwitchToggleComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SwitchToggleComponent implements ControlValueAccessor {
  // Two-way binding
  @Input() checked = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  // ControlValueAccessor
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};
  disabled = false;

  writeValue(value: any): void {
    this.checked = !!value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // when we click
  onToggle(event: Event) {
    if (this.disabled) return;
    const input = event.target as HTMLInputElement;
    this.checked = input.checked;

    // Update ControlValueAccessor
    this.onChange(this.checked);
    this.onTouched();

    // Update two-way binding
    this.checkedChange.emit(this.checked);
  }
}
